<template lang="pug">

  div

    //-
      -
      - ?
      -
      -

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

    //-
      -
      - ?
      -
      -

    v-dialog(v-model="dialog" max-width="500" @click:outside="clearPlan")

      //- v-card(v-if="!pending && !edited || edited" class="elevation-12")
      //- v-card.elevation-12
      v-card(v-if="!pending" class="elevation-12")

        v-card-text

          v-overlay(:value="loading")
            v-progress-circular(indeterminate size="64")

          div(style="text-align:center;")

            h2 {{ selectedPlanName }}
            h2 {{ selectedPlanPrice }}

          v-form(v-model="valid")

            v-autocomplete(v-model="objForm.country" :items="countries" label="País" required :rules="[v => !!v || 'País é obrigatório!']")
            v-text-field(v-model="objForm.name" label="Nome Completo" type="text" :rules="[v => !!v || 'Nome é obrigatório!']" required)
            v-text-field(v-model="objForm.email" name="email" label="E-Mail" type="text" :rules="[v => !!v || 'E-Mail é obrigatório!']" disabled required)

            v-text-field(v-if="objForm.country === 'BR'" v-model="objForm.phone" v-mask="'(##) ##### ####'" name="phone" label="Celular" type="text" :rules="[v => (!v || v.length < 15) ? 'Celular inválido!' : false]" required)
            v-text-field(v-else v-model="objForm.phone" name="phone2" label="Celular" type="text" :rules="[v => !!v || 'Celular é obrigatório!']" required)

            div(v-if="objForm.country === 'BR'")

              v-text-field(v-model="objForm.cpf" v-mask="['###.###.###-##', '##.###.###/####-##']" name="cpf" label="CPF/CNPJ" type="text" :rules="[v => checkCpfCnpj(v)]" required)
              v-text-field(v-model.lazy="objForm.birth" label="Data de Nascimento" type="text" maxlength="10" :rules="[v => !!v && isValidDate(v) ? true : 'Informe a data de nascimento!' /* return !!v && isValidDate(v) || 'Data de Nascimento é obrigatório!' */]" required @input="formatBirthdate")
              v-text-field(v-model="objForm.zipcode" v-mask="'#####-###'" label="Cep" type="text" :rules="[v => !!v || 'Cep é obrigatório!']" required)
              v-text-field(v-model="objForm.street" label="Rua" type="text" :rules="[v => !!v || 'Rua é obrigatório!']" required)
              v-text-field(v-model="objForm.number" label="Número" type="text" :rules="[v => !!v || 'Número é obrigatório!']" required)
              v-text-field(v-model="objForm.complement" label="Complemento" type="text")
              v-text-field(v-model="objForm.district" label="Bairro" type="text" :rules="[v => !!v || 'Bairro é obrigatório!']" required)
              v-text-field(v-model="objForm.city" label="Cidade" type="text" :rules="[v => !!v || 'Cidade é obrigatório!']" required)
              v-text-field(v-model="objForm.state" label="Estado" type="text" :rules="[v => !!v || 'Estado é obrigatório!']" required)

              v-select(v-model="objForm.pay_method" :items="[{text: 'Cartão de Crédito / Paypal', value: 'credit_card'}, {text: 'Boleto', value: 'bank_slip'}]" label="Forma de Pagamento" required)

            div(v-else)

              v-select(v-model="objForm.pay_method" :items="[{text: 'Cartão de Crédito / Paypal', value: 'credit_card'}]" label="Forma de Pagamento" required)

            div Você vai receber um e-mail com as instruções de pagamento

        v-card-actions

          v-spacer
          sos-button(@buttonClick="dialogTerms = true" buttonLabel="EFETUAR PAGAMENTO" buttonIcon="" buttonIconSize="20" :disabled="!formIsFilled")

          //- v-btn(color="primary" :disabled="!formIsFilled" @click="dialogTerms = true")
            | EFETUAR PAGAMENTO

      //- v-card(v-if="pending && !edited" class="elevation-12")
      v-card(v-if="pending" class="elevation-12")
        v-card-text
          h2 Aguardando pagamento
          p.mt-3.mb-3 Verifique o seu e-mail {{ objForm.email }}
          a(v-if="paymentUrl.length > 0" :href="paymentUrl" target="_blank") Abrir fatura

          //- p(v-if="lastCharge !== null && lastCharge.print_url")
            a(:href="lastCharge.print_url") LINK PARA PAGAMENTO

          //- p(v-if="lastCharge !== null && !lastCharge.print_url && lastCharge.pay.url")
            a(:href="lastCharge.pay.url") LINK PARA PAGAMENTO

          //- div(v-if="lastCharge !== null && !lastCharge.print_url && !lastCharge.pay.url")
            | não foi possivel efetuar a cobrança, confira os seus dados e tente novamente.
            v-btn(color="primary" @click="edited = true")
              | CORRIGIR OS DADOS E TENTAR EFETUAR PAGAMENTO NOVAMENTE

    //-
      -
      - ?
      -
      -

    v-dialog(v-model="dialogTerms" width="600px")

      v-card

        v-card-title
          span.text-h5 Termos de Uso

        v-card-text
          terms-of-use

        v-card-actions

          v-spacer

          sos-button(@buttonClick="dialogTerms = false" buttonLabel="RECUSAR" buttonIcon="" buttonIconSize="20" color="blue").mr-3
          sos-button(@buttonClick="save" buttonLabel="ACEITAR" buttonIcon="" buttonIconSize="20")

    //-
      -
      - ?
      -
      -

    //- v-dialog(v-model="dialogPolicy" width="600px")
      v-card
        v-card-title
          span.text-h5 {{ policy.title }}
        v-card-text(v-html="policy.content")
        v-card-actions
          v-spacer
          sos-button(@buttonClick="dialogPolicy = false" buttonLabel="RECUSAR" buttonIcon="" buttonIconSize="20" color="blue").mr-3
          sos-button(@buttonClick="save()" buttonLabel="ACEITAR" buttonIcon="" buttonIconSize="20")

</template>

<script>

  import { countries } from '@/constants'
  import { apiMakePayment, apiGetUserPaymentProfile, apiGetAddressByCep } from '@/services/users'

  import confirmDialogMixin from '@/mixins/cd.mixin.js'
  import cpfMixin from '@/mixins/cpf.mixin'
  import cnpjMixin from '@/mixins/cnpj.mixin'

  import SosButton from '@/components/SosButton'
  import ConfirmDialog from '@/modals/ConfirmDialog'
  import TermsOfUse from '@/components/TermsOfUse'

  import { getPlanName } from '@/utils.js'

  import moment from 'moment'
  import 'moment/locale/pt-br'

  moment.locale('pt-BR')

  //
  //
  //

  export default {
    name: 'PaymentModal',

    components: {
      'sos-button': SosButton,
      'confirm-dialog': ConfirmDialog,
      'terms-of-use': TermsOfUse,
    },

    mixins: [
      cpfMixin,
      cnpjMixin,
      confirmDialogMixin,
    ],

    props: {
      selectedPlan: {
        type: Object,
        default: () => (null),
      },
      clearPlan: {
        type: Function,
        default: () => {},
      },
    },

    // https://vuejsexamples.com/button-morphing-into-form/

    data: () => ({
      loading: false,
      valid: false,
      dialogTerms: false,

      // dialogPolicy: false,
      // policy: {},

      objForm: {
        birth: null,
        country: 'BR',
        name: null,
        phone: null,
        email: null,
        cpf: null,
        pay_method: 'credit_card',
        zipcode: null,
        street: null,
        number: null,
        district: null,
        complement: null,
        city: null,
        state: null,
        plan_id: null,
        plan_api_id: null,
      },
      countries: [],
      edited: false,
      // lastCharge: '',

      pending: false,
      paymentUrl: '',
    }),

    computed: {
      selectedPlanName () {
        // [24/01/25] console.log('selectedPlanName:', this.selectedPlan)
        return this.selectedPlan && this.selectedPlan.id ? getPlanName(this.selectedPlan.id, true) : ''
      },

      selectedPlanPrice () {
        if (this.selectedPlan && this.selectedPlan.price > 0) {
          return this.selectedPlan.price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } else {
          return 'R$ 0,00'
        }
      },

      formIsFilled () {
        const { objForm } = this
        const {
          country,
          name,
          phone,
          email,
          // pay_method,
          zipcode,
          street,
          number,
          district,
          city,
          state,
          birth,
          // plan_id,
          // plan_api_id,
        } = objForm

        const payMethod = this.objForm.pay_method

        if (
          !country ||
          !name ||
          !phone ||
          !email ||
          !this.isValidDocument() ||
          !birth ||
          (birth && !this.isValidDate(birth)) ||
          !payMethod ||
          !zipcode ||
          !street ||
          !number ||
          !district ||
          !city ||
          !state
        ) {
          return false
        } else {
          return true
        }
      },

      dialog () {
        return Boolean(this.selectedPlan)
      },
    },

    watch: {
      'objForm.zipcode': {
        deep: true,
        async handler (cep)
        {
          const cepString = !!cep === true ? cep.replace(/[^0-9]/g, '') : ''

          if (/^[0-9]{8}$/.test(cepString))
          {
            const response = await apiGetAddressByCep(cepString)

            if (response.httpCode !== 200)
            {
              this.showMessage('Falha!', 'Não foi possível consultar o CEP!<br /><br /><b>Motivo</b>:<br />' + (response.message || response.httpCode))
            }
            else
            {
              this.objForm.street = response.logradouro || ''
              this.objForm.district = response.bairro || ''
              this.objForm.city = response.localidade || ''
              this.objForm.state = response.uf || ''
            }
          }
        },
      },
    },

    //
    // LOAD PROFILE
    //

    async created ()
    {
      // [24/01/25] console.log('PaymentModal[getProfile][userToken]:', this.$store.state.app.userSession.userToken)

      //
      // GET COUNTRIES
      //

      // this.objForm.country = "BR"

      countries.forEach(o => {
        this.countries.push({ text: o.country_name, value: o.country_code })
      })

      //
      // GET USER
      //

      const response = await apiGetUserPaymentProfile(this.$store.state.app.userSession.userToken)

      if (response.code === 0)
      {
        this.showMessage(response.title, response.message)
      }
      else
      {
        this.objForm.country = response.message.country || 'BR'
        // this.objForm.country = 'BR'
        this.objForm.name = response.message.name || ''
        this.objForm.email = response.message.email || ''
        this.objForm.phone = response.message.phone || ''
        this.objForm.cpf = response.message.cpf || ''
        this.objForm.zipcode = response.message.zipcode || ''
        this.objForm.street = response.message.street || ''
        this.objForm.number = response.message.number || ''
        this.objForm.district = response.message.district || ''
        this.objForm.complement = response.message.complement || ''
        this.objForm.city = response.message.city || ''
        this.objForm.state = response.message.state || ''
        this.objForm.birth = response.message.birth ? moment(response.message.birth, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''

        // [24/01/25] console.log('mySelf:', response.message)
      }

      // await this.getPlans(config)
      // this.terms = await this.getPage('Termos', config)
      // this.policy = await this.getPage('Política de Privacidade', config)
    },

    methods: {
      checkCpfCnpj (v) {
        if (!!v === true) {
          if (v.length === 14 && !this.isValidCPF(v)) {
            return 'CPF Inválido!'
          } else if (v.length === 18 && !this.isValidCNPJ(v)) {
            return 'CNPJ Inválido!'
          } else {
            if (v.length !== 14 && v.length !== 18) {
              return 'Por favor, complete o CPF/CNPJ!'
            } else {
              return true
            }
          }
        } else {
          return 'CPF/CNPJ é obrigatório!'
        }
      },

      isValidDate (date) {
        const isValid = /(\d{2})\/(\d{2})\/(\d{4})$/.test(date)
        if (!isValid) {
          return false
        } else {
          // console.log(date, output)
          return moment(date, 'DD/MM/YYYY').isValid()
        }
      },

      formatBirthdate () {
        const value = this.objForm.birth
        let v = value.replace(/\D/g, '').slice(0, 8)
        // let v = this.objForm.birth
        // Remove tudo o que não é dígito
        // v = v.replace(/\D/g, '')
        v = v.replace(/(\d{2})(\d)/, '$1/$2')
        v = v.replace(/(\d{2})(\d)/, '$1/$2')
        v = v.replace(/(\d{2})(\d{2})$/, '$1$2')
        v = v.slice(0, 10)
        this.$nextTick(() => {
          this.objForm.birth = v
        })
      },

      isValidDocument: function () {
        const { cpf } = this.objForm // CPF/CNPJ

        if (cpf.length === 14) {
          return this.isValidCPF(cpf)
        } else if (cpf.length === 18) {
          return this.isValidCNPJ(cpf)
        } else if (cpf.length !== 14 && cpf.length !== 18) {
          return false
        } else {
          return true
        }
      },

      async save ()
      {
        this.dialogTerms = false
        // dialogPolicy = false

        if (!this.isValidDocument() || !this.objForm.birth || (this.objForm.birth && !this.isValidDate(this.objForm.birth))) return false

        // this.dialogPolicy = false

        if (this.objForm.country === 'BR') {
          this.objForm.cpf = this.objForm.cpf.replace(/[^0-9]/g, '')
          this.objForm.zipcode = this.objForm.zipcode.replace(/[^0-9]/g, '')
        }

        const _cou = countries.find(o => o.country_code === this.objForm.country)

        this.objForm.plan_id = this.selectedPlan.id
        this.objForm.phone = this.objForm.phone.replace(/[^0-9]/g, '')
        this.objForm.plan_api_id = this.selectedPlan.api_id
        this.objForm.edited = this.edited
        this.objForm.country_phone = _cou.dialling_code + this.objForm.phone
        // this.objForm.country_phone = '+55' + this.objForm.phone
        this.objForm.birth = moment(this.objForm.birth, 'DD/MM/YYYY').format('YYYY-MM-DD')
        // this.objForm.birth = '30/06/2021'

        //
        //
        //

        this.loading = true
        const response = await apiMakePayment(this.objForm, this.$store.state.app.userSession.userToken)
        this.loading = false

        this.showMessage(response.title, response.message)

        if (response.code === 1)
        {
          if (response.pay.status === 'paid') {
            document.location.reload()
          }

          if (response.pay.status === 'pending') {
            this.pending = true
            this.paymentUrl = response.pay.url
            // window.location.href = response.pay.url
          }
        }
      },

      //
      //
      //
      //
      //
      //
      //

      cdAction (cdResponse)
      {
        // console.log('::: cdAction:', cdResponse)
      },
    },
  }

</script>
